import {Pipe, PipeTransform} from '@angular/core';

import {endOfWeekOn, format, isSameMonth, isSameYear, startOfWeekOn} from '../../shared/utils/date';
import {isPresent} from '../utils/lang';

@Pipe({
  name: 'gpDateRange',
  pure: false
})
export class CalendarDateRangePipe implements PipeTransform {

  public transform(viewDate: Date, view: string): string {
    if (viewDate instanceof Date && isPresent(view)) {
      if (view === 'month') {
        return `${format(viewDate, 'MMMM')}`;
      } else if (view === 'week') {
        const start = startOfWeekOn(viewDate, 1);
        const end = endOfWeekOn(start, 1);
        if (isSameMonth(start, end) || isSameYear(start, end)) {
          return `${format(start, 'MMM D')} – ${format(end, 'MMM D')}`;
        } else {
          return `${format(start, 'MMM D, YYYY')} – ${format(end, 'MMM D, YYYY')}`;
        }
      }
    }
  }
}
